import { stripBasePath } from './transposedRoutes';

// Fail-closed (opposite of shouldTransposeChrome's fail-open default): a
// missed noindex risks exposing customer data, while a missed transpose is
// merely cosmetic. Only the bare base path (stripBasePath -> '') is
// indexable; every other pathname, including ones outside the base path
// (stripBasePath -> null), is noindexed.
export const isNoIndexed = (pathname: string | undefined | null): boolean =>
  stripBasePath(pathname) !== '';
